import { registerCommonPopover } from '@/commons/popoverRegister/commonPopoverRegister.js';
export function registerPopover(app) {
  registerCommonPopover(app);
}
